import React from "react";
import { connect } from "react-redux";
import "../../styles/Empresa.css";
import { Link } from "react-router-dom";
import { URL, getAuthorizationHeader, idEmpresa, admin } from '../../constans/constants';
import Navbar from "../home/Navbar";
import MensajeFlash from '../mensajeFlash/MensajeFlash';
import { getReportesUsuarios } from './ReportesService';
import visibility from '../../styles/icons/visibility.svg';
import { Button } from 'react-bootstrap';
import search from "../../styles/icons/search.svg";
import Spinner from "react-bootstrap/Spinner";

class ReportesEmpleados extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedReportesEmpleados: {
        usuario: "",
        identificador: "",
        nombres: "",
        apellidos: "",
        cedula: "",
        email: "",
        id: "",
      },
      dialogIsOpen: false,
      mostrarMensajeFlash: false,
      open: false,
      mensajeFlash: "",
      severity: "",
      loading: true,
      search: "",
      pageSize: 10
    };
    localStorage.setItem("urlRaiz", window.location.href);
    this.tableRef = React.createRef();

  }
  handleDialog = (value, mensaje = "", severity = "") => {
    if (value === false) {
      this.tableRef.current.onQueryChange();  //Para actualizar la grilla
      this.setState({
        mensajeFlash: mensaje,
        severity: severity
      });
      if (mensaje != "") {
        this.setState({
          mostrarMensajeFlash: true
        });
      }
    }
    this.setState({ dialogIsOpen: value });
  };
  componentDidUpdate(prevProps) {
    if (prevProps.loading && !this.props.loading) {
      this.tableRef.current && this.tableRef.current.onQueryChange();
    }
  }
  handleImportarLote = () => {
    this.handleDialog(true);
    this.tableRef.current.onQueryChange();
  }
  handleCloseMensajeFlash = () => {
    this.setState({
      mostrarMensajeFlash: false,
    });
  };
  descargarReporteRecibosXls = () => {
    window.location.href = URL + "reportes/recibos/usuarios/descargar/xls?idEmpresa=" + idEmpresa();
  }
 handlePageChange(newPage) {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchRecibos(newPage, this.state.pageSize, "");
      });
    }
  }
  componentDidMount() {
    this.fetchRecibos(0, this.state.pageSize, "");
  }
  
  handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchRecibos(this.state.page, this.state.pageSize, "");
      });
    }
  };

  handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize: newPageSize, page: 0 }, () => {
      this.fetchRecibos(this.state.page, this.state.pageSize, "");
    });
  };

  renderPageNumbers() {
    const { page, totalPages } = this.state;
    const maxVisiblePages = 5; // Máximo de páginas visibles

    let pages = [];

    if (totalPages <= maxVisiblePages) {
      // Mostrar todas las páginas si son pocas
      for (let i = 0; i < totalPages; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">{i + 1}</a>
          </li>
        );
      }
    } else {
      // Mostrar primeras páginas, últimas y cercanas a la actual
      const startPage = Math.max(0, page - 2);
      const endPage = Math.min(totalPages - 1, page + 2);

      // Agregar primera página
      if (startPage > 0) {
        pages.push(
          <li
            key={0}
            className={`page-item ${page === 0 ? "active" : ""}`}
            onClick={() => this.handlePageChange(0)}
          >
            <a className="page-link" type="Button">1</a>
          </li>
        );
        if (startPage > 1) {
          pages.push(
            <li key="start-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
      }

      // Agregar páginas visibles
      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">{i + 1}</a>
          </li>
        );
      }

      // Agregar última página
      if (endPage < totalPages - 1) {
        if (endPage < totalPages - 2) {
          pages.push(
            <li key="end-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
        pages.push(
          <li
            key={totalPages - 1}
            className={`page-item ${page === totalPages - 1 ? "active" : ""}`}
            onClick={() => this.handlePageChange(totalPages - 1)}
          >
            <a className="page-link" type="Button">{totalPages}</a>
          </li>
        );
      }
    }

    return pages;
  }



  fetchRecibos(page, pageSize, search) {
    this.setState({loading:true})
    this.props.getReportesUsuarios(page, pageSize, search).then(() => {
      this.setState({
        recibos: this.props.reporteUsuarioData.reporteUsuario,
        page: this.props.reporteUsuarioData.page,
        totalCount: this.props.reporteUsuarioData.totalCount,
        totalPages: Math.ceil(this.props.reporteUsuarioData.totalCount / pageSize),
        loading: false 
      });
    });
  }
  
  handleSearchChange = (e) => {
    const searchValue = e.target.value;
    this.setState({ search: searchValue }, () => {
      this.fetchRecibos(0, this.state.pageSize, this.state.search);
    });
  };


  render() {
    return (
      <div>
        <div className="component-pagination">
          <h5 className="list-title">Todos</h5>
          <div className="pagination-actions">

            <form className="search-form form">
              <div className="search-group">
                <div className="input-icon">
                  <span className="material-symbols-outlined">search</span>
                </div>
                <input
                  type="search"
                  className="input-search"
                  placeholder="Buscar.."
                  aria-label="Search"
                  value={this.state.search}
                  onChange={this.handleSearchChange}
                />
              </div>
            </form>

            <div className="pagination">
              <span className="info-pages">
                {this.state.page * this.state.pageSize + 1}-
                {Math.min(
                  (this.state.page + 1) * this.state.pageSize,
                  this.state.totalCount
                )}{" "}
                de {this.state.totalCount}
              </span>

              <button
                className={`btn-prev ${this.state.page === 0 ? "btn-disabled" : ""
                  }`}
                onClick={() => this.handlePageChange(this.state.page - 1)}
                disabled={this.state.page === 0}
              >
                <span className="material-symbols-outlined">navigate_before</span>
              </button>

              <button
                className={`btn-next ${this.state.page === this.state.totalPages - 1
                  ? "btn-disabled"
                  : ""
                  }`}
                onClick={() => this.handlePageChange(this.state.page + 1)}
                disabled={this.state.page === this.state.totalPages - 1}
              >
                <span className="material-symbols-outlined">navigate_next</span>
              </button>
            </div>
          </div>
        </div>
        <div>
                          {this.state.loading ? (
                // Muestra el spinner mientras loading sea true
                <div className="d-flex justify-content-center p-5">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                  </Spinner>
                </div>
              ) : (
              <div className="component-lista-simple activar-paginador">
                <div className="component-container">
                  {this.props.reporteUsuarioData.reporteUsuario.map((recibo, index) => (
                    <Link to={{ pathname: '/reporte/' + recibo.nombreApellido + '/recibos/' + recibo.id }}
                        style={{ textDecoration: 'none' }}>

                    <div key={index} className="list-item item-pending">
                        <div className="item-info">
                          <div className="item-copy">
                            <span className="copy__title">
                              {recibo.nombreApellido}
                            </span>
                          </div>
                          </div>
                          <div class="item-elements">
                            <h3 className="item__number">
                              {recibo.cantidadRecibo} Documentos
                            </h3>
                            <p className="item__ci">
                              CI. {recibo.cedula}
                            </p>
                        </div>

                    </div>
                    </Link>
                  ))}
                </div>
              </div>)}

            <MensajeFlash
              mensaje={this.state.mensajeFlash}
              severity={this.state.severity}
              open={this.state.mostrarMensajeFlash}
              handleClose={this.handleCloseMensajeFlash} />
          </div>
        </div>

    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getReportesUsuarios: (page, size, search) => dispatch(getReportesUsuarios(page, size, search))
});
const mapStateToProps = (state) => ({
  reporteUsuarioData: state.reporteUsuarioData,
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportesEmpleados);
